/**
 * NetworkBanner component displays a warning banner when the app is offline.
 * Receives network status from App component via NetworkMonitoringService.
 */
import React from 'react'
import './NetworkBanner.scss'

interface INetworkBannerProps {
    isOnline: boolean
}

export const NetworkBanner: React.FC<INetworkBannerProps> = ({ isOnline }) => {
    // Only show banner when offline
    if (isOnline) {
        return null
    }

    return (
        <div className="network-banner">
            {/* TODO: Replace with translated string - https://app.asana.com/1/8442528107068/project/1210908264295868/task/1213278967091036 */}
            No internet connection. App may not work as expected.
        </div>
    )
}
